import React from 'react';

import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { ServicePageLayoutComponent } from 'design/servicePageLayout';
import { LinkControlComponent } from 'design/linkControl';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { TextComponent } from 'design/text/textComponents';
import { LogoComponent } from 'design/logo';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';

type Props = {
  noLogo?: boolean;
};

export const DefaultAsyncFallback = (props: Props) => {
  return (
    <ServicePageLayoutComponent
      size="l"
      sidebarContent={
        !props.noLogo && (
          <LinkControlComponent to={ORIGIN_SITE_URL}>
            <TextComponent size="l">
              <LogoComponent />
            </TextComponent>
          </LinkControlComponent>
        )
      }
      bodyContent={
        <CenteredLayoutComponent noOverlay>
          <SpinnerExtraLarge />
        </CenteredLayoutComponent>
      }
    />
  );
};
